<template>
  <header>
    <figure>
      <a href="javascript:;" class="logo"
        ><img alt="Bangkok Hospital" src="/images/Bangkok-Hospital.png"
      /></a>
      <div class="btn-group btn-lg head_custom">
        <button
          class="dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ language.toUpperCase() }}
        </button>
        <ul class="dropdown-menu" style="min-width: unset !important">
          <li v-for="(res, k) in languageList" :key="k">
            <a class="dropdown-item" @click="language = res.value">{{
              res.text
            }}</a>
          </li>
        </ul>
      </div>
      <div class="version">
        {{ version }}
      </div>
    </figure>
  </header>
</template>

<script>
export default {
  data() {
    return {
      languageList: [],
      languageListTH: [
        { text: 'TH', value: 'TH' },
        { text: 'EN', value: 'EN' },
      ],
      languageListEN: [
        { text: 'TH', value: 'TH' },
        { text: 'EN', value: 'EN' },
      ],
      version: 'V ' + process.env.VUE_APP_VERNO,
    }
  },
  methods: {},
  computed: {
    language: {
      get() {
        return this.$store.state.language
      },
      set(lang) {
        this.$store.commit('UPDATE_LANGUAGE', lang)
      },
    },
  },
  watch: {
    language(lang) {
      if (lang == 'TH') {
        this.languageList = this.languageListTH
      } else {
        this.languageList = this.languageListEN
      }
    },
  },
  mounted() {
    if (this.$store.state.language == 'TH') {
      this.languageList = this.languageListTH
    } else {
      this.languageList = this.languageListEN
    }
  },
}
</script>

<style scoped>
.btn:hover,
.btn:active {
  border: unset !important;
}

.head_custom {
  position: absolute;
  right: 25px;
  font-weight: bold;
  font-size: 30px !important;
}
.head_custom button {
  width: 38px;
  background: transparent;
  color: #000;
  font-size: 23px;
  font-weight: 400;
  margin-top: 38px;
}
@media only screen and (max-width: 576px) {
  .head_custom button {
    font-size: 16px;
    font-weight: 300;
  }
}

@media only screen and (max-width: 500px) {
  .head_custom button {
    margin-top: 27px;
  }
}
@media only screen and (max-width: 430px) {
  .head_custom button {
    margin-top: 10px;
  }
}
@media only screen and (max-width: 414px) {
}

@media (max-width: 378px) {
}

header figure {
  position: relative; /* สำคัญมาก */
}

.version {
  position: absolute;
  bottom: 5px;
  right: 25px;
  font-size: 14px;
  color: #999;
}
</style>
